<div style="width: 100%; height: 400px" fxLayoutAlign="center center">
  <h2>
    {{ 'externalSharedService.payment_success' }}
  </h2>
</div>
